import { BACKEND_HTTP, SESSION_LOOKUP_PATH } from './config';
import type { SessionMetadata } from './types';

export async function fetchSessionByCode(code: string): Promise<SessionMetadata> {
  const url = `${BACKEND_HTTP}${SESSION_LOOKUP_PATH}/${encodeURIComponent(code.toUpperCase())}`;
  const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
  if (!res.ok) {
    let body: any = null;
    try { body = await res.json(); } catch { /* */ }
    const code = body?.code ?? `HTTP_${res.status}`;
    const message = body?.message ?? `Request failed (${res.status})`;
    throw Object.assign(new Error(message), { code });
  }
  return (await res.json()) as SessionMetadata;
}
